var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"vi-help-problem--box"},_vm._l((_vm.data),function(el,$index){return (el.status === 1)?_c('div',{key:$index,staticClass:"vi-help-problem--box__item",on:{"click":function($event){return _vm.onToPath()}}},[_c('a',{attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.tru(el.questionTitle,13)))])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"vi-help--item__more",on:{"click":function($event){return _vm.onToPath()}}},[_c('a',{attrs:{"href":"javascript:"}},[_vm._v("了解更多")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vi-help--item__title"},[_c('b',[_vm._v("常见问题")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/helpProblem.vue